/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svchip_Worker_PoolsInputs */

const en_svchip_worker_pools = /** @type {(inputs: Svchip_Worker_PoolsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Worker pools`)
};

const ar_svchip_worker_pools = /** @type {(inputs: Svchip_Worker_PoolsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`مجموعات العمال`)
};

const bn_svchip_worker_pools = /** @type {(inputs: Svchip_Worker_PoolsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ওয়ার্কার পুল`)
};

const de_svchip_worker_pools = /** @type {(inputs: Svchip_Worker_PoolsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Worker-Pools`)
};

const es_svchip_worker_pools = /** @type {(inputs: Svchip_Worker_PoolsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Grupos de trabajadores`)
};

const fr_svchip_worker_pools = /** @type {(inputs: Svchip_Worker_PoolsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pools de nœuds de calcul`)
};

const pt_svchip_worker_pools = /** @type {(inputs: Svchip_Worker_PoolsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Grupos de trabalhadores`)
};

const zh_svchip_worker_pools = /** @type {(inputs: Svchip_Worker_PoolsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`工作池`)
};

const tr_svchip_worker_pools = /** @type {(inputs: Svchip_Worker_PoolsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Worker pools`)
};

const ru_svchip_worker_pools = /** @type {(inputs: Svchip_Worker_PoolsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Рабочие пулы`)
};

const pl_svchip_worker_pools = /** @type {(inputs: Svchip_Worker_PoolsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pule procesów roboczych`)
};

/**
* | output |
* | --- |
* | "Worker pools" |
*
* @param {Svchip_Worker_PoolsInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const svchip_worker_pools = /** @type {((inputs?: Svchip_Worker_PoolsInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svchip_Worker_PoolsInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svchip_worker_pools(inputs)
	if (locale === "bn") return bn_svchip_worker_pools(inputs)
	if (locale === "de") return de_svchip_worker_pools(inputs)
	if (locale === "es") return es_svchip_worker_pools(inputs)
	if (locale === "fr") return fr_svchip_worker_pools(inputs)
	if (locale === "pt") return pt_svchip_worker_pools(inputs)
	if (locale === "zh") return zh_svchip_worker_pools(inputs)
	if (locale === "tr") return tr_svchip_worker_pools(inputs)
	if (locale === "ru") return ru_svchip_worker_pools(inputs)
	if (locale === "pl") return pl_svchip_worker_pools(inputs)
	return en_svchip_worker_pools(inputs)
});